import { render, staticRenderFns } from "./sendBack.vue?vue&type=template&id=fd6def08&scoped=true"
import script from "./sendBack.vue?vue&type=script&lang=js"
export * from "./sendBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6def08",
  null
  
)

export default component.exports